import { Dialog, Alert } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
    show: boolean;
    errorCode: number;
    errorMessage: string;
    closeModal: () => void;
};

const RawDataErrorModal = ({
    show,
    closeModal,
    errorCode,
    errorMessage,
}: Props) => {
    const { t } = useTranslation();
    const errorMessageToDisplay =
        errorCode === 500
            ? t('rawDataModal.error', { ns: 'components' })
            : t(errorMessage, { ns: 'backend' });
    return (
        <Dialog open={show} onClose={closeModal} maxWidth={false}>
            <Alert
                sx={{ width: '100%', padding: '2rem' }}
                severity={[401, 403].includes(errorCode) ? 'info' : 'error'}
                onClose={closeModal}
            >
                {errorMessageToDisplay}
            </Alert>
        </Dialog>
    );
};

export default RawDataErrorModal;
